<mat-toolbar class="justify-content-between align-items-center prada-white-bg pl-0 pr-3 fixed-top">
  <div class="container-fluid">
    <div class="row flex-nowrap align-items-center">
      <div class="col-auto brand-logo">
        <img class="logo cursor-pointer"
          (click)="onGoToHome()"
          src="assets/images/brands/logo_prada_group.png" />
      </div>
      <div class="col">
        <ng-content></ng-content>
      </div>
      <ng-container *ngIf="!hideActions">
        <div class="col-auto ml-auto user-section flex-shrink-1 p-0 mr-4">
          <div class="user-section user-section--clickable"
            *bitfUiRoleManager="isMeetUserRoleConfig"
            #userSectionTriggerMenu="matMenuTrigger"
            [matMenuTriggerFor]="userMenu">
            <fa-icon [icon]="faUserCircle"
              class="icon-m mr-2"></fa-icon>
            <div class="user"
              [showIfTruncated]="true"
              [enableMobile]="true"
              [title]="storeService?.store?.user?.displayName">
              {{storeService?.store?.user?.displayName}}
            </div>
            <fa-icon icon="faChevronDown"
              class="ml-2 icon-xs"
              *ngIf="userSectionTriggerMenu.menuOpen"></fa-icon>
            <fa-icon [icon]="faChevronDown"
              class="ml-2 icon-xs"
              *ngIf="!userSectionTriggerMenu.menuOpen"></fa-icon>
          </div>
        </div>
        <mat-menu #userMenu="matMenu">
          <!-- <div class="menu-user-item"
            [routerLink]="['/booking/import']">
            <fa-icon icon="file-upload"
              class="icon-m mr-2">
            </fa-icon>
            <span>{{'WEB.BOOKING.IMPORT' | translate}}</span>
          </div> -->
          <div class="menu-user-item"
            *bitfUiRoleManager="{action: ERoleActions.ANONYMIZE_DATA, mode: ERoleMode.HIDDEN}"
            [routerLink]="['/export']">
            <fa-icon [icon]="faFileExport"
              class="icon-m mr-2"></fa-icon>
            <span>{{'COMMON.LABEL.EXPORT' | translate}}</span>
          </div>
        </mat-menu>
        <div class="col-auto p-0">
          <fa-icon [icon]="faPowerOff"
            title="{{'COMMON.LABEL.LOGOUT' | translate}}"
            class="icon-s cursor-pointer"
            (click)="onLogout()"></fa-icon>
        </div>
        <div class="col-auto p-0 ml-3"
          *bitfUiRoleManager="{action: ERoleActions.MANAGE_JOBS, mode: ERoleMode.HIDDEN}">
          <fa-icon [icon]="faTasks"
            title="{{'COMMON.LABEL.SCHEDULED_JOBS' | translate}}"
            class="icon-s cursor-pointer"
            (click)="onManageScheduledJobs()"></fa-icon>
        </div>
      </ng-container>
    </div>
  </div>
</mat-toolbar>